export default "__VITE_PUBLIC_ASSET__f1252647__"